import { motion } from 'framer-motion'
import Image from 'next/image'

import { useAppDispatch } from '@/hooks'
import { settingsActions } from '@/redux/reducers/settings/setting.reducer'
import SVGS from '@/assets/svgs'

import styles from './styles.module.css'

const BtnOpenSideBar = () => {
  const dispatch = useAppDispatch()

  return (
    <div className={styles.openSideBar}>
      <motion.button
        onClick={() => dispatch(settingsActions.setMenu(true))}
        initial={{ x: -300 }}
        animate={{ x: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Image src={SVGS.menu} alt="menu" width={40} height={40} />
      </motion.button>
    </div>
  )
}

export default BtnOpenSideBar
